import CardWithAdornmentComponent from './CardWithAdornmentComponent';
export * from './CardWithAdornmentComponent';
export default CardWithAdornmentComponent;
